import { ScheduledQuery } from '@api/api/scheduled-queries';

import { defaultPromptFormValue, PromptFormValue } from '../PromptForm';

export const scheduledQueryToPromptFormValue = (
  task: ScheduledQuery,
  scheduleEnabled: boolean
): PromptFormValue => {
  const { cadence } = task;

  return {
    title: task.title,
    query: task.request.message,
    scheduleEnabled,
    frequency: cadence?.frequency ?? defaultPromptFormValue.frequency,
    day: cadence?.day_of_week ?? defaultPromptFormValue.day,
    occurrence: cadence?.occurrence ?? defaultPromptFormValue.occurrence,
    deliveryTime: cadence?.time_window ?? defaultPromptFormValue.deliveryTime,
    skipWeekends: cadence?.skip_weekends ?? defaultPromptFormValue.skipWeekends,
  };
};
